<template>
    <div ref="scroll">
        <div class="content" ref="content">
            <slot></slot>
        </div>
    </div>
</template>
<script>
import BScroll from 'better-scroll'
import ResizeObserver from 'resize-observer-polyfill'
export default {
    props:{
        options:Object
    },
    data: function() {
        return {
            optionFinal:{
                click:true,
                probeType:3,
                bounce: {
                    top:false,
                    bottom:false
                },
                mouseWheel: {
                    speed: 20,
                    invert: false,
                    easeTime: 300
                },
                preventDefaultException:{
                    tagName:/^(a)$/
                },
                nestedScroll:true,
                ...this.options
            }
        }
    },
    methods: {
        detectResizeWapper(){
            this.viewDetec=new ResizeObserver(()=>{
                this.$emit('resize',this.$refs.scroll);
                this.scroll.refresh();
            });
            this.viewDetec.observe(this.$refs.scroll);
        },
        detectResizeInner(){
            this.contentDetec=new ResizeObserver(()=>{
                this.scroll.refresh();
            });
            this.contentDetec.observe(this.$refs.content);
        },
        infoEvent(){
            this.scroll.on('touchEnd', () => {
                this.$emit('touchEnd',this.scroll);
            })
            this.scroll.on('scroll', (position) => {
                this.$emit('scroll',position);
            })
        }
    },
    updated(){
        this.scroll.refresh();
    },
    mounted(){
        this.scroll=new BScroll(this.$refs.scroll,this.optionFinal);
        this.infoEvent();
        this.detectResizeWapper();
        this.detectResizeInner();
        this.$emit('mounted',this.$refs.scroll);
        setTimeout(()=>{
            this.scroll.refresh();
        },500);
        
    },
    beforeDestroyed() {
        if(this.viewDetec) {
            this.viewDetec.disconnect()
            this.viewDetec.takeRecords()
            this.viewDetec = null
        }
    }
};
</script>
